import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import PropTypes from 'prop-types';
import React from 'react';

import useStyles from './styles';

export const Modal = ({
  ariaLabelledBy,
  children,
  onClose,
  fullScreenOnMobile,
  maxWidth,
  blurOverlay,
  open,
  ...props
}) => {
  const classes = useStyles({ fullScreenOnMobile, maxWidth });

  return (
    <Dialog
      aria-labelledby={ariaLabelledBy}
      classes={{ paper: classes.modal }}
      fullScreen={fullScreenOnMobile}
      fullWidth
      onClose={onClose}
      open={open}
      {...(blurOverlay && {
        BackdropProps: { classes: { root: classes.blurredBackdrop } },
      })}
      maxWidth={false}
      {...props}
    >
      {children}
    </Dialog>
  );
};

Modal.propTypes = {
  ariaLabelledBy: PropTypes.string.isRequired, // must match id on modal title
  blurOverlay: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  fullScreenOnMobile: PropTypes.bool,
  maxWidth: PropTypes.number,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
};

Modal.defaultProps = {
  blurOverlay: false,
  fullScreenOnMobile: true,
  maxWidth: 636,
};

export default withMobileDialog({ breakpoint: 'xs' })(Modal);
